import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { ParagraphSmall } from '@finect/tabular-core/Paragraph';
export var FooterNotes = styled(ParagraphSmall).withConfig({
  displayName: "partials__FooterNotes",
  componentId: "sc-1bcvg2l-0"
})(["max-width:100%;", ";"], getFont(0));